import cn from 'classnames';

export type StatusTone =
  | 'positive'
  | 'warning'
  | 'info'
  | 'negative'
  | 'neutral';

const toneToDotClass: Record<StatusTone, string> = {
  positive: 'bg-positive-accent',
  warning: 'bg-warning-accent',
  info: 'bg-[#0B92D3]',
  negative: 'bg-[#E53935]',
  neutral: 'bg-[#9E9E9E]',
};

type Props = {
  tone: StatusTone;
  children: React.ReactNode;
  className?: string;
};

export const StatusBadge = ({ tone, children, className }: Props) => (
  <span
    className={cn('flex items-center gap-1.5 whitespace-nowrap', className)}
  >
    <span
      className={cn('size-2 shrink-0 rounded-full', toneToDotClass[tone])}
    />
    <span>{children}</span>
  </span>
);
